export default __webpack_public_path__ + "assets/images/winter-c33b2503.png";